import React, { Component } from 'react'
import styles from '../style.module.less'
import indexStore from '../Tabs/store'
import { observer } from 'mobx-react'
import ModalIf from '@common/ModalIf'
import store from '../SetBack/store'
import mainStore from '@components/Main/store'

@observer
export default class extends Component {
  render() {
    const {
      list,
      back_status,
      reason,
      giftModal,
      onCancelGift,
      promiseModal,
      onCancelPromise
    } = indexStore
    const {
      merchantInfo: { is_special_merchant }
    } = mainStore

    return (
      <div className={styles.brief}>
        {(is_special_merchant == 1 || is_special_merchant == 2) && (
          <p style={{ marginBottom: 10, fontSize: 14 }}>
            <i className={styles.attention}>i</i>
            {is_special_merchant == 1 && (
              <span>您的设置和修改将同步至所有的店铺，子店铺无法修改</span>
            )}
            {is_special_merchant == 2 && (
              <span>
                您无法修改当前设置，系统将默认认为您同步主门店的相关设置
              </span>
            )}
          </p>
        )}

        {(back_status == 3 || back_status == 4) &&
          is_special_merchant != 2 && (
            <div className={styles.pendingMsg}>
              <img src="http://qnm.hunliji.com/o_1b3c9uqm9am31qpf1rd9qr1c437.png" />
              {back_status == 3 && (
                <span>审核中！在审核结束后，您将收到我们的通知</span>
              )}
              {back_status == 4 && <span>{reason}</span>}
            </div>
          )}

        {back_status != 0 && (
          <div
            className={styles.modify}
            style={{
              marginBottom:
                back_status == 1 || back_status == 3 || back_status == 4
                  ? '0'
                  : '25px'
            }}
          >
            {(back_status == 3 || back_status == 4) && '已选“订单可退”服务内容'}
            {back_status != 3 && back_status != 4 && '订单可退服务'}
            {back_status == 2 &&
              is_special_merchant != 2 && (
                <a
                  className={styles.btnPrimary}
                  onClick={indexStore.openTools(6)}
                >
                  开启
                </a>
              )}
            {back_status != 0 &&
              back_status != 2 &&
              is_special_merchant != 2 && (
                <div style={{ float: 'right' }}>
                  <span
                    className={styles.btnDefault}
                    onClick={store.closePromise}
                  >
                    关闭
                  </span>
                  <a
                    className={styles.btnPrimary}
                    href="#/localMerchant/marketingTools/setBack"
                  >
                    修改
                  </a>
                </div>
              )}
          </div>
        )}

        {(back_status == 1 || back_status == 3 || back_status == 4) && (
          <ul
            className={styles.promiseUl}
            style={{
              border: '1px solid #e7e7e7',
              borderTop: 0,
              paddingTop: 40
            }}
          >
            {(list || [])
              .filter(({ status }) => status == 1)
              .map(({ id, detail, image_path, main }) => {
                return (
                  <li key={id}>
                    <img src={image_path} />
                    <div>
                      <p>{main}</p>
                      <p>{detail}</p>
                    </div>
                  </li>
                )
              })}
          </ul>
        )}

        <div className={styles.introduction}>
          {(back_status == 0 || back_status == 2) && (
            <div>
              <img src="http://qnm.hunliji.com/o_1a9a68ce1vng16g0jnc16u5a6af.jpg" />
              <img src="http://qnm.hunliji.com/o_1alp8dt2h1do12pq1la517v0j37.jpg" />

              <ul className={styles.promiseUl} style={{ width: 876 }}>
                {(list || []).map(({ id, detail, image_path, main }) => (
                  <li key={id}>
                    <img src={image_path} />
                    <div>
                      <p>{main}</p>
                      <p>{detail}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {back_status == 0 &&
            is_special_merchant != 2 && (
              <span onClick={indexStore.openTools(6)}>立即开通</span>
            )}
        </div>

        <ModalIf
          type={giftModal.type}
          isShow={giftModal.isShow}
          content={giftModal.content}
          btn1={giftModal.btn1}
          btn2={giftModal.btn2}
          hrefVal={giftModal.hrefVal}
          onClick={onCancelGift}
        />

        <ModalIf
          type={promiseModal.type}
          isShow={promiseModal.isShow}
          content={promiseModal.content}
          btn1={promiseModal.btn1}
          btn2={promiseModal.btn2}
          hrefVal={promiseModal.hrefVal}
          onClick={onCancelPromise}
        />
      </div>
    )
  }
}
